/**
 * Tailwind/CSS-class implementation of the AccordionTrigger wrapper.
 * Uses the Seeds accordion CSS classes from accordion.css.
 */

import React, { useContext } from "react";
import { AccordionContext } from "./Accordion";
import { AccordionTriggerInner } from "./AccordionTriggerInner";
import { type TypeAccordionTriggerProps } from "./AccordionTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const AccordionTriggerTailwind = ({
  children,
  leftSlot,
  relatedActions,
  overflowMenu,
  rightSlot,
  title,
  headingLevel = "h4",
  className,
  // In the Tailwind path the hybrid gate guarantees no styled-system props are
  // present. `color` is still pulled out so it is forwarded to the inner content
  // (overflow menu / related actions) but not onto the wrapper div.
  color,
  ...triggerProps
}: TypeAccordionTriggerProps) => {
  const { triggerIcon, triggerPosition, styled } = useContext(AccordionContext);

  return (
    <div
      className={cn("seeds-accordion-trigger", className)}
      data-styled={styled}
      data-qa-trigger="HERE"
      {...(triggerProps as React.HTMLAttributes<HTMLDivElement>)}
    >
      <AccordionTriggerInner
        title={title}
        headingLevel={headingLevel}
        leftSlot={leftSlot}
        rightSlot={rightSlot}
        relatedActions={relatedActions}
        overflowMenu={overflowMenu}
        color={color}
        triggerIcon={triggerIcon}
        triggerPosition={triggerPosition}
      />
    </div>
  );
};
